import React from 'react';
import { Box } from '@mui/material';

interface SectionContainerProps {
  color: string;
  children: any;
  onClick?: () => void;
}

export const SectionContainer = ({
  color,
  onClick,
  children,
}: SectionContainerProps) => {
  return (
    <Box onClick={onClick} sx={{
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      backgroundColor: '#FAFAFA',
      marginTop: '14px',
      borderRadius: '8px',
      borderBottom: `2px solid ${color}`,
      padding: '10px 10px 8px',
      cursor: onClick ? 'pointer': 'default',
    }}>
      {children}
    </Box>
  );
}
